
    import Vue from 'vue';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
export const conditions_new = [
  {
    label: $t('7fb6ad'),
    value: 'eq',
    type: 1,
    tag: 'or',
    valueAs: 'in',
    mark_id: 0,
    label_encode: '%E9%80%89%E6%8B%A9',
    label_en: 'Select',
  },
  {
    label: $t('2cdd97'),
    value: 'neq',
    type: 1,
    tag: 'and',
    valueAs: 'nin',
    mark_id: 1,
    label_encode: '%E6%9C%AA%E9%80%89%E6%8B%A9',
    label_en: 'Unselected',
  },
  {
    label: $t('3580ac'),
    value: 'contain',
    type: 1,
    tag: 'or',
    valueAs: 'contain',
    rmsType: 1,
    mark_id: 2,
    label_encode: '%E5%8C%85%E5%90%AB',
    label_en: 'Include',
  },
  {
    label: $t('9b303c'),
    value: 'not_contain',
    type: 1,
    tag: 'or',
    valueAs: 'not_contain',
    rmsType: 1,
    mark_id: 3,
    label_encode: '%E4%B8%8D%E5%8C%85%E5%90%AB',
    label_en: 'Not included ',
  },
  {
    label: $t('f3828f'),
    value: 'zdy',
    type: 3,
    tag: 'and',
    valueAs: 'contain',
    mark_id: 4,
    label_encode: '%E8%87%AA%E5%AE%9A%E4%B9%89',
    label_en: 'Customize ',
  },
  {
    label: $t('488005'),
    value: 'eq',
    type: 2,
    tag: 'or',
    valueAs: 'in',
    rmsType: 2,
    mark_id: 5,
    label_encode: '%E7%AD%89%E4%BA%8E',
    label_en: 'Equiv. to',
  },
  {
    label: $t('ece43e'),
    value: 'neq',
    type: 2,
    tag: 'and',
    valueAs: 'nin',
    mark_id: 6,
    label_encode: '%E4%B8%8D%E7%AD%89%E4%BA%8E',
    label_en: 'Not equal',
  },
  {
    label: $t('9c83fb'),
    value: 'gt',
    type: 2,
    tag: 'and',
    valueAs: 'gt',
    rmsType: 2,
    mark_id: 7,
    label_encode: '%E5%A4%A7%E4%BA%8E',
    label_en: 'Gt',
  },
  {
    label: $t('948773'),
    value: 'gte',
    type: 2,
    tag: 'and',
    valueAs: 'gte',
    rmsType: 2,
    mark_id: 8,
    label_encode: '%E5%A4%A7%E4%BA%8E%E7%AD%89%E4%BA%8E',
    label_en: 'Greater than or equal',
  },
  {
    label: $t('d60a3f'),
    value: 'lt',
    type: 2,
    tag: 'and',
    valueAs: 'lt',
    rmsType: 2,
    mark_id: 9,
    label_encode: '%E5%B0%8F%E4%BA%8E',
    label_en: 'Less than',
  },
  {
    label: $t('489409'),
    value: 'lte',
    type: 2,
    tag: 'and',
    valueAs: 'lte',
    rmsType: 2,
    mark_id: 10,
    label_encode: '%E5%B0%8F%E4%BA%8E%E7%AD%89%E4%BA%8E',
    label_en: 'Less than/equal to',
  },
  {
    label: $t('25cfec'),
    value: 'between',
    type: 2,
    tag: 'contain',
    valueAs: 'contain',
    mark_id: 11,
    label_encode: '%E4%BB%8B%E4%BA%8E',
    label_en: 'Between',
  },
  {
    label: $t('47f6c2'),
    value: 'keyword',
    type: 10,
    tag: 'in',
    valueAs: 'in',
    mark_id: 12,
    label_encode: '%E5%85%B3%E9%94%AE%E8%AF%8D',
    label_en: 'Keywords ',
  },
  {
    label: $t('e5556a'),
    value: 'emotional',
    type: 11,
    tag: 'or',
    valueAs: 'eq',
    mark_id: 13,
    label_encode: '%E6%83%85%E6%84%9F',
    label_en: 'Emotion ',
  },
  {
    label: $t('4350ef'),
    value: 'complaint',
    type: 12,
    tag: 'eq',
    valueAs: 'eq',
    mark_id: 14,
    label_encode: '%E5%AE%A2%E8%AF%89',
    label_en: 'Complaint',
  },
  {
    label: $t('d63a96'),
    value: 'voice_sentiment_category',
    type: 13,
    tag: 'eq',
    valueAs: 'eq',
    mark_id: 15,
    label_encode: '%E6%83%85%E7%BB%AA',
    label_en: 'Emotion',
  },
  {
    label: $t('e42724'),
    value: 'cem_voice_room_type',
    type: 14,
    tag: 'or',
    valueAs: 'in',
    mark_id: 16,
    label_encode: '%E5%88%86%E6%9C%BA%E7%8A%B6%E6%80%81',
    label_en: 'Status',
  },
  {
    label: $t('fe6a60'),
    value: 'cem_custom_department',
    type: 15,
    tag: 'eq',
    valueAs: 'eq',
    mark_id: 17,
    label_encode: '%E8%87%AA%E5%AE%9A%E4%B9%89%E9%83%A8%E9%97%A8',
    label_en: 'Dept defined',
  },
  {
    label: $t('b48960'),
    value: 'alert_level',
    type: 12,
    tag: 'eq',
    valueAs: 'eq',
    mark_id: 18,
    label_encode: '%E9%A2%84%E8%AD%A6%E7%AD%89%E7%BA%A7',
    label_en: 'Warning level',
  },
  {
    // 触发次数大于
    label: decodeURIComponent('%E8%A7%A6%E5%8F%91%E6%AC%A1%E6%95%B0%E5%A4%A7%E4%BA%8E'),
    value: 'history_same_label_count',
    type: 16,
    tag: 'gt',
    valueAs: 'gt',
    mark_id: 19,
    label_encode: '%E8%A7%A6%E5%8F%91%E6%AC%A1%E6%95%B0%E5%A4%A7%E4%BA%8E',
    label_en: 'Same label count greater than',
  },
]
export const conditions = [
  {
    label: $t('7fb6ad'),
    value: 'eq',
    type: 1,
    tag: 'or',
  },
  {
    label: $t('2cdd97'),
    value: 'neq',
    type: 1,
    tag: 'and',
  },
  {
    label: $t('3580ac'),
    value: 'contain',
    type: 1,
    processType: false,
    tag: 'or',
  },
  {
    label: $t('f3828f'),
    value: 'zdy',
    type: 3,
    tag: 'and',
  },
  {
    label: $t('488005'),
    value: 'eq',
    type: 2,
    tag: 'or',
  },
  {
    label: $t('ece43e'),
    value: 'neq',
    type: 2,
    tag: 'and',
  },
  {
    label: $t('9c83fb'),
    value: 'gt',
    type: 2,
    tag: 'and',
  },
  {
    label: $t('948773'),
    value: 'gte',
    type: 2,
    tag: 'and',
  },
  {
    label: $t('d60a3f'),
    value: 'lt',
    type: 2,
    tag: 'and',
  },
  {
    label: $t('489409'),
    value: 'lte',
    type: 2,
    tag: 'and',
  },
]
export const operatorList = [
  {
    value: 'GT',
    label: $t('9c83fb'),
  },
  {
    value: 'GTE',
    label: $t('948773'),
  },
  {
    value: 'LT',
    label: $t('d60a3f'),
  },
  {
    value: 'LTE',
    label: $t('489409'),
  },
  {
    value: 'EQ',
    label: $t('488005'),
  },
  {
    value: 'BETWEEN',
    label: $t('25cfec'),
  },
]
// 情感
export const emotional = [
  {
    value: '',
    label: $t('16853b'),
  },
  {
    value: 'positive',
    label: $t('0e1638'),
  },
  {
    value: 'neutral',
    label: $t('2eb100'),
  },
  {
    value: 'bad',
    label: $t('56c5de'),
  },
]
// 数据类型
export const dataType = [
  {
    key: 'type-0',
    value: 0,
    label: $t('e4b3ae'),
  },
  {
    key: 'type-1',
    value: 1,
    label: $t('5f382f'),
  },
  {
    key: 'type-3',
    value: 3,
    label: $t('1e2fff'),
  },
  {
    key: 'type-2',
    value: 2,
    label: $t('2c480b'),
  },
  {
    key: 'type-4',
    value: 4,
    label: $t('64b151'),
  },
  {
    key: 'type-5',
    value: 5,
    label: $t('4d39e5'),
  },
  {
    key: 'type-6',
    value: 6,
    label: $t('8bd364'),
  },
  {
    key: 'type-7',
    value: 7,
    label: $t('081a57'),
  },
]

export const dataType_new = VocDeepClone.deepClone(dataType).filter(item => item.value !== 6 && item.value !== 7)
export const sourceType = {
  3: $t('1e2fff'),
  1: $t('5f382f'),
  2: $t('2c480b'),
  4: $t('64b151'),
  5: $t('4d39e5'),
  6: $t('8bd364'),
  7: $t('081a57'),
}

export const opersType = [
  {
    value: 'and',
    label: $t('16853b'),
  },
  {
    value: 'or',
    label: $t('22cfbe'),
  },
]

export const warningRuleStatus = [
  {
    value: -1,
    label: $t('16853b'),
  },
  {
    value: 0,
    label: $t('ba4d99'),
  },
  {
    value: 1,
    label: $t('572fbe'),
  },
]

export const models = [
  {
    value: 1,
    label: isRms() ? 'RMS' : $t('cc43ce'),
  },
  // {
  //   value: 2,
  //   label: "模型"
  // }
]

export const statusName = { 1: $t('889b3e'), 0: $t('4551d4') }
export const statusColor = { 1: '#B8C1D0', 0: '#73C03F' }
export const statusText = { 0: $t('ba4d99'), 1: $t('572fbe') }
export const taskMap = [
  {
    value: -1,
    label: $t('16853b'),
  },
  {
    value: 2,
    label: $t('2d13b6'),
  },
  {
    value: 1,
    label: $t('d939d4'),
  },
  {
    value: 3,
    label: $t('8b9b30'),
  },
  {
    value: 4,
    label: $t('af2d33'),
  },
  {
    value: 10,
    label: $t('ce764b'),
  },
]

export const displayContent = {
  pie_doughnut: $t('82604b'),
  indicator_card: $t('fa1284'),
  gauge: $t('2744f6'),
  columnar: $t('3bdef9'),
  columnar_stack: $t('825c59'),
  columnar_stack_line: $t('ee0b03'),
  bar: $t('517686'),
  bar_stack: $t('5a69f1'),
  bar_stack_line: $t('a9670a'),
  broken_line: $t('e9524f'),
  table: $t('104709'),
  area: $t('c77a88'),
  pie: $t('67905b'),
  dict: $t('72f988'),
  box: $t('ebdc11'),
  thematic_analysis: $t('afe02c'),
  scatter: $t('ed7d53'),
  text_analysis: $t('a24421'),
  radar: $t('d92e42'),
  // 内容
  same: $t('6168b8'),
  sequential: $t('56afdf'),
  mentions_top_10: $t('7de931'), // --1
  nps_top_10: $t('7da9c0'), // --1
  nps_reciprocal_10: $t('c5f7d1'), // --1
  mention_rate: $t('200987'), // --2
  nps_change_rate: $t('f2033d'), // --2
  emotional_changes_rate: $t('335350'), // --2
  comment_change: $t('644629'),
  comment_reciprocal_5: $t('5c42b7'),
  emotional_reciprocal_5: $t('de5ca3'),
  mentions_top_5: $t('d2bcbe'),
  satisfaction_top_5: $t('97e4b0'),
  satisfaction_reciprocal_5: $t('a8b8d1'),
  vnps: 'NPS Pro',
  nps: 'NPS',
  mentions: $t('9b4263'),
  positive: $t('9b9e0f'),
  neutral: $t('db8a78'),
  negative: $t('cb2919'),
  supportContentTypeExclusive: [],
  supportChartTypeList: [],
}

export const typeList = { 1: $t('380da9'), 2: $t('5d819c'), 3: $t('43a358'), 4: $t('aea420') }
export const typeName = { 1: 'T', 2: '#', 3: 'D', 4: '♬' }
export const typeNumber = { T: 1, '#': 2, D: 3, '♬': 4 }
export const typeColor = { T: '#50bc7a', '#': '#fea50a', D: '#67a7eb', '♬': '#C55253' }
export const fieldTypeList = [
  {
    value: 'T',
    label: $t('380da9'),
  },
  {
    value: 'D',
    label: $t('43a358'),
  },
  {
    value: '#',
    label: $t('5d819c'),
  },
  {
    value: '♬',
    label: $t('aea420'),
  },
]
export const PHONE_NOTIFICATION = 2
export const SMS_NOTIFICATION = 1
export const EMAIL_NOTIFICATION = 3
export const ROBOT_NOTIFICATION = 4
export const WORKORDER_NOTIFICATION = 10
export const WECHAT_NOTIFICATION = 6
export const taskWayList = [
  {
    value: PHONE_NOTIFICATION,
    label: $t('55658e'),
  },
  {
    value: SMS_NOTIFICATION,
    label: $t('394eb6'),
  },
  {
    value: ROBOT_NOTIFICATION,
    label: $t('67fa03'),
  },
  {
    value: WORKORDER_NOTIFICATION,
    label: $t('0bcf8e'),
  },
  {
    value: WECHAT_NOTIFICATION,
    label: $t('390169'),
  },
  {
    value: EMAIL_NOTIFICATION,
    label: $t('07f55b'),
  },
]

export const notifyWayConfig = { 4: $t('08c3a4') }

export const operationList = [
  {
    type: 'editor',
    name: $t('6267f3'),
  },
  {
    type: 'enable',
    name: $t('889b3e'),
  },
  {
    type: 'disable',
    name: $t('4551d4'),
  },
  {
    type: 'copy',
    name: $t('29f67f'),
  },
  {
    type: 'delete',
    name: $t('e33c9b'),
  },
]

export const robotType = {
  1: $t('cd551e'),
  2: $t('3c1847'),
  3: $t('e7149f'),
}

// 参考线值类型
export const lineValueType = { int: true, percent: false }
// 任务频率
export const taskFrequency = [
  {
    value: 0,
    label: $t('90b251'),
  },
  {
    value: 60,
    label: $t('7fc898'),
  },
  {
    value: 3600,
    label: $t('e15c1d'),
  },
  {
    value: 7200,
    label: $t('2be514'),
  },
  {
    value: 21600,
    label: $t('2a7c5c'),
  },
  {
    value: 43200,
    label: $t('85852b'),
  },
  {
    value: 86400,
    label: $t('9329be'),
  },
]
// 优先级
export const priorityList = [
  {
    value: 10,
    label: $t('c052e0'),
  },
  {
    value: 20,
    label: $t('317039'),
  },
  {
    value: 30,
    label: $t('93c9ea'),
  },
  {
    value: 40,
    label: $t('5f2f41'),
  },
]
// 解决时长
export const sloveList = [
  {
    value: 300,
    label: $t('e399d2'),
  },
  {
    value: 600,
    label: $t('2b44ce'),
  },
  {
    value: 900,
    label: $t('d07c2f'),
  },
  {
    value: 1800,
    label: $t('7b0809'),
  },
  {
    value: 3600,
    label: $t('bd4dad'),
  },
  {
    value: 7200,
    label: $t('c44d6a'),
  },
  {
    value: 28800,
    label: $t('df81e7'),
  },
  {
    value: 43200,
    label: $t('bc5b47'),
  },
  {
    value: 53200,
    label: $t('9593fc'),
  },
]
// 预警规则升级时间
export const upgradeTimeList = [
  {
    value: 300,
    label: $t('e399d2'),
  },
  {
    value: 600,
    label: $t('2b44ce'),
  },
  {
    value: 900,
    label: $t('d07c2f'),
  },
  {
    value: 1800,
    label: $t('7b0809'),
  },
]
// 监控周期
export const taskMonitoringPeriod = [
  {
    value: 'zdy',
    label: $t('f3828f'),
  },
  {
    value: 'day',
    label: $t('fadfae'),
  },
  {
    value: 'week',
    label: $t('2c4f7d'),
  },
  {
    value: 'month',
    label: $t('c232ab'),
  },
  {
    value: 'quarter',
    label: $t('827d3b'),
  },
  {
    value: 'year',
    label: $t('5d4c76'),
  },
]
export const recordColors = { positive: '#00b6b6', bad: '#DC6583', neutral: '#909399' }
// 图表只支持NPS数字或是百分比
export const nps_mutex = ['columnar', 'bar', 'columnar_stack', 'bar_stack', 'radar']

/*
{
  // 数据源列ID
  columnId: 'TJUEIWPGNDSOPGNTEOWPJTOI',
  // 数据列名称
  columnName: '',
  // 类型'percent'|'number'|'text' (text类型的暂时无法设置颜色,需要先过滤)
  columnType: '', 
  // 关联的显示内容
  contentTypeKeyList: ['nps', 'same']
  // 颜色配置
  colorsConfig: [
    {
      // 选择的颜色
      color: '',
      // GT: 大于 GTE: 大于等于 LT: 小于 LTE: 小于等于 EQ: 等于 BETWEEN: 介于
      calculate: 'GT',
      // value数组,如果是介于则数组长度为2
      value: [10],
    }
    // more...
  ]
},
*/

// 默认颜色
export const defaultColor = [
  {
    color: '#31BFBF',
    calculate: 'GT',
    value: [0],
  },
  {
    color: '#EE6E6E',
    calculate: 'LT',
    value: [0],
  },
]

// 指标统计 biModelId: comment_score_coreq_detail
export const comment_score_coreq_detail = [
  {
    columnName: 'NPS Pro',
    columnId: 'sen_rate',
    columnIdAs: 'sen_rate',
    columnType: 'percent',
    contentTypeKeyList: ['vnps'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '正面情感占比',
    columnId: 'pos_rate',
    columnIdAs: 'pos_rate',
    columnType: 'percent',
    contentTypeKeyList: ['vnps'],
    colorsConfig: [],
  },
  {
    columnName: '负面情感占比',
    columnId: 'neg_rate',
    columnIdAs: 'neg_rate',
    columnType: 'percent',
    contentTypeKeyList: ['vnps'],
    colorsConfig: [],
  },
  {
    columnName: '提及量',
    columnId: 'hit_count',
    columnIdAs: 'hit_count',
    columnType: 'number',
    contentTypeKeyList: ['mentions'],
    colorsConfig: [],
  },
  {
    columnName: '提及率',
    columnId: 'hit_rate',
    columnIdAs: 'hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['mentions'],
    colorsConfig: [],
  },
  {
    columnName: '正面量',
    columnId: 'pos_count',
    columnIdAs: 'pos_count',
    columnType: 'number',
    contentTypeKeyList: ['positive'],
    colorsConfig: [],
  },
  {
    columnName: '正面率',
    columnId: 'pos_hit_rate',
    columnIdAs: 'pos_hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['positive'],
    colorsConfig: [],
  },
  {
    columnName: '中立量',
    columnId: 'neu_count',
    columnIdAs: 'neu_count',
    columnType: 'number',
    contentTypeKeyList: ['neutral'],
    colorsConfig: [],
  },
  {
    columnName: '中立率',
    columnId: 'neu_hit_rate',
    columnIdAs: 'neu_hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['neutral'],
    colorsConfig: [],
  },
  {
    columnName: '负面量',
    columnId: 'neg_count',
    columnIdAs: 'neg_count',
    columnType: 'number',
    contentTypeKeyList: ['negative'],
    colorsConfig: [],
  },
  {
    columnName: '负面率',
    columnId: 'neg_hit_rate',
    columnIdAs: 'neg_hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['negative'],
    colorsConfig: [
      {
        color: '#EE6E6E',
        calculate: 'GT',
        value: [0],
      },
    ],
  },
]

// 指标NPS统计 biModelId: nps_text_coreq_detail
export const nps_text_coreq_detail = [
  {
    columnName: 'NPS',
    columnId: 'nps_rate',
    columnIdAs: 'nps_rate',
    columnType: 'percent',
    contentTypeKeyList: ['nps'],
    colorsConfig: [],
  },
  {
    columnName: '同比',
    columnId: 'nps_rate_tbd',
    columnIdAs: 'nps_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '环比',
    columnId: 'nps_rate_hbd',
    columnIdAs: 'nps_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: 'NPS影响度',
    columnId: 'influence_rate',
    columnIdAs: 'influence_rate',
    columnType: 'percent',
    contentTypeKeyList: ['influence_rate'],
    colorsConfig: [],
  },
  {
    columnName: 'NPS影响度同比',
    columnId: 'influence_rate_tbd',
    columnIdAs: 'influence_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['influence_rate', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: 'NPS影响度环比',
    columnId: 'influence_rate_hbd',
    columnIdAs: 'influence_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['influence_rate', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '推荐率',
    columnId: 'good_rate',
    columnIdAs: 'good_rate',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'positive'],
    colorsConfig: [],
  },
  {
    columnName: '推荐率同比',
    columnId: 'good_rate_tbd',
    columnIdAs: 'good_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'positive', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '推荐率环比',
    columnId: 'good_rate_hbd',
    columnIdAs: 'good_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'positive', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '贬损率',
    columnId: 'bad_rate',
    columnIdAs: 'bad_rate',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'negative'],
    colorsConfig: [
      {
        color: '#EE6E6E',
        calculate: 'GT',
        value: [0],
      },
    ],
  },
  {
    columnName: '贬损率同比',
    columnId: 'bad_rate_tbd',
    columnIdAs: 'bad_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'negative', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '贬损率环比',
    columnId: 'bad_rate_hbd',
    columnIdAs: 'bad_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['nps', 'negative', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '提及量',
    columnId: 'hit_count',
    columnIdAs: 'hit_count',
    columnType: 'number',
    contentTypeKeyList: ['mentions'],
    colorsConfig: [],
  },
  {
    columnName: '提及率',
    columnId: 'hit_rate',
    columnIdAs: 'hit_rate',
    columnType: 'percent',
    contentTypeKeyList: ['mentions'],
    colorsConfig: [],
  },
  {
    columnName: '提及率同比',
    columnId: 'hit_rate_tbd',
    columnIdAs: 'hit_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['mentions', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '提及率环比',
    columnId: 'hit_rate_hbd',
    columnIdAs: 'hit_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['mentions', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '正面量',
    columnId: 'pos_count',
    columnIdAs: 'pos_count',
    columnType: 'number',
    contentTypeKeyList: ['positive'],
    colorsConfig: [],
  },
  {
    columnName: '正面率',
    columnId: 'pos_rate',
    columnIdAs: 'pos_rate',
    columnType: 'percent',
    contentTypeKeyList: ['positive'],
    colorsConfig: [],
  },
  {
    columnName: '正面率同比',
    columnId: 'pos_rate_tbd',
    columnIdAs: 'pos_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['positive', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '正面率环比',
    columnId: 'pos_rate_hbd',
    columnIdAs: 'pos_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['positive', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '中立量',
    columnId: 'neu_count',
    columnIdAs: 'neu_count',
    columnType: 'number',
    contentTypeKeyList: ['neutral'],
    colorsConfig: [],
  },
  {
    columnName: '中立率',
    columnId: 'neu_rate',
    columnIdAs: 'neu_rate',
    columnType: 'percent',
    contentTypeKeyList: ['neutral'],
    colorsConfig: [],
  },
  {
    columnName: '中立率同比',
    columnId: 'neu_rate_tbd',
    columnIdAs: 'neu_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['neutral', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '中立率环比',
    columnId: 'neu_rate_hbd',
    columnIdAs: 'neu_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['neutral', 'sequential'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '负面量',
    columnId: 'neg_count',
    columnIdAs: 'neg_count',
    columnType: 'number',
    contentTypeKeyList: ['negative'],
    colorsConfig: [],
  },
  {
    columnName: '负面率',
    columnId: 'neg_rate',
    columnIdAs: 'neg_rate',
    columnType: 'percent',
    contentTypeKeyList: ['negative'],
    colorsConfig: [
      {
        color: '#EE6E6E',
        calculate: 'GT',
        value: [0],
      },
    ],
  },
  {
    columnName: '负面率同比',
    columnId: 'neg_rate_tbd',
    columnIdAs: 'neg_rate_tbd',
    columnType: 'percent',
    contentTypeKeyList: ['negative', 'same'],
    colorsConfig: defaultColor,
  },
  {
    columnName: '负面率环比',
    columnId: 'neg_rate_hbd',
    columnIdAs: 'neg_rate_hbd',
    columnType: 'percent',
    contentTypeKeyList: ['negative', 'same'],
    colorsConfig: defaultColor,
  },
]

export const predefineColors = ['#33BFBF', '#598EE7', '#F4C943', '#FF7D51', '#975AD0', '#49BCE8', '#EE6E6E']

export const countWay = [
  {
    calculateId: 'count',
    describe: '计数',
    name: '计数',
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'distinct',
    describe: '去重',
    name: '去重',
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'sum',
    describe: '求和',
    name: '求和',
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'avg',
    describe: '平均值',
    name: '平均值',
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'max',
    describe: '最大值',
    name: '最大值',
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'min',
    describe: '最小值',
    name: '最小值',
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'stddev',
    describe: '标准差',
    name: '标准差',
    presetConfig: {
      valueType: 'number',
    },
  },
  {
    calculateId: 'nps',
    describe: 'NPS',
    name: 'NPS',
    presetConfig: {
      valueType: 'percent',
    },
  },
  {
    calculateId: 'survey_score_percent',
    name: '得分率',
    describe: '得分率',
    presetConfig: {
      // 预设配置
      valueType: 'percent', // 百分比
    },
  },
  {
    calculateId: 'survey_question_score_percent',
    name: '答题得分率',
    describe: '答题得分率',
    presetConfig: {
      // 预设配置
      valueType: 'percent', // 百分比
    },
  },
  {
    calculateId: 'survey_calculate_avg_score_percent',
    name: '算术平均得分率',
    describe: '算术平均得分率=得分/答题总分的平均',
    presetConfig: {
      // 预设配置
      valueType: 'percent', // 百分比
    },
  },
]

export const complaintType = [
  {
    value: 'S',
    label: 'S类客诉(高危/严重事件)',
  },
  {
    value: 'A',
    label: 'A类客诉(高差评风险事件)',
  },
  {
    value: 'B',
    label: 'B类客诉(中差评风险事件)',
  },
  {
    value: 'C',
    label: 'C类客诉(用户吐槽事件)',
  },
]

export const complaintType_EN = [
  {
    value: 'S',
    label: 'Class S (High-risk/severe events)',
  },
  {
    value: 'A',
    label: 'Class A(High negative review risk)',
  },
  {
    value: 'B',
    label: 'Class B(Medium negative review risk)',
  },
  {
    value: 'C',
    label: 'Class C(Users complain events)',
  },
]

/**
 * {
  "ColumnType=1 And ProcessType=1" : // 文本并且文本分析
  {
    "Type" : ["value", "values"], // 支持表达式类型,
    "Operate" : ["eq", "neq", "contain", "in", "nin"], // 支持的操作符
    "Func" : ["keyword", "sentiment_category"], // 支持的函数
  },
  "ColumnType=1 And ProcessType=0" : // 文本
  {
      "Type" : ["value", "values"], // 支持表达式类型,
      "Operate" : ["eq", "neq", "contain", "in", "nin"], // 支持的操作符
      "Func" : ["keyword"], // 支持的函数
  },
  "ColumnType=2" : // 数值
  {
    "Type" : ["value", "values"], // 支持表达式类型,,
    "Operate" : ["eq", "neq", "lt", "gt", "lte", "gte", "in", "nin"], // 支持的操作符
    "Func" : [], // 支持的函数
  },
  "ColumnType=3" : // 日期
  {
    "Type" : ["value", "values", "between"], // 支持表达式类型,
    "Operate" : ["eq", "neq", "lt", "gt", "lte", "gte"], // 支持的操作符
    "Func" : [], // 支持的函数
  },
}
 */

export function isRms() {
  // return location?.href.startsWith('http://localhost')
  return location?.href.startsWith('https://rms')
}

// 数据源类型
// 点评
export const DATASOURCEREVIEW = 2
// 语音
export const DATASOURCEVOICE = 4
// 酒店调价历史
export const DATASOURCERMS = 5
// 未来30天酒店起价
export const DATASOURCERMSBOTTOMPRICE = 6
// 当日小时级间夜数据
export const DATASOURCERMSROOMNIGHT = 7
